import type { SalesforceDescription, SalesforceField, SalesforceLayout, SalesforceObjectSummary } from './formImport';
import { type SalesforceFormObjectsQuery, type SalesforceLayoutsQuery, type SalesforceObjectDescriptionQuery } from './SalesforceMetadata.generated';
export function mapObjects(objects: SalesforceFormObjectsQuery['salesforceObjects']): SalesforceObjectSummary[] {
  return objects.flatMap(object => object.createable ? [{
    apiName: object.name,
    label: object.label || object.name,
    custom: object.custom,
    createable: true
  }] : []);
}
export function mapDescription(description: SalesforceObjectDescriptionQuery['salesforceObjectDescription']): SalesforceDescription {
  return {
    apiName: description.name,
    label: description.label || description.name,
    custom: description.custom,
    createable: description.createable,
    fields: description.fields.map(mapField)
  };
}
export function mapLayouts(layouts: SalesforceLayoutsQuery['salesforceLayouts']): SalesforceLayout[] {
  return layouts.map(layout => ({
    id: layout.id,
    label: layout.label,
    sections: layout.sections.map(section => ({
      id: section.id,
      label: section.label,
      fieldApiNames: section.fieldApiNames
    }))
  }));
}
function mapField(field: SalesforceObjectDescriptionQuery['salesforceObjectDescription']['fields'][number]): SalesforceField {
  return {
    apiName: field.name,
    label: field.label || field.name,
    type: field.type,
    custom: field.custom,
    createable: field.createable,
    nillable: field.nillable,
    calculated: field.calculated,
    autoNumber: field.autoNumber,
    defaultedOnCreate: field.defaultedOnCreate,
    length: field.length,
    helpText: field.inlineHelpText,
    picklistValues: field.picklistValues,
    referenceTo: field.referenceTo
  };
}